import { render } from "./BannerEdit.vue?vue&type=template&id=491f210e"
import script from "./BannerEdit.vue?vue&type=script&lang=js"
export * from "./BannerEdit.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__